/**
 * ****************************************************************************
 * @description     :   Route for bs app
 * @created at      :   2022/03/24
 * @created by      :   ANS874 – quanhvm@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const bm001000i = () => import('@/views/bm/bm001000i');
const bm001000l = () => import('@/views/bm/bm001000l');
const bm002000i = () => import('@/views/bm/bm002000i');
const bm002000l = () => import('@/views/bm/bm002000l');
const bm003000i = () => import('@/views/bm/bm003000i');
const bm003000l = () => import('@/views/bm/bm003000l');
const bm004000i = () => import('@/views/bm/bm004000i');
const bm005000i = () => import('@/views/bm/bm005000i');
const bm005000l = () => import('@/views/bm/bm005000l');
const bm004000l = () => import('@/views/bm/bm004000l');
const bm006000i = () => import('@/views/bm/bm006000i');
const bm007000l = () => import('@/views/bm/bm007000l');
const bm007000i = () => import('@/views/bm/bm007000i');
const bm008000l = () => import('@/views/bm/bm008000l');
const bm009000i = () => import('@/views/bm/bm009000i');
const bm009000l = () => import('@/views/bm/bm009000l');
const bm010000l = () => import('@/views/bm/bm010000l');
const bm010000i = () => import('@/views/bm/bm010000i');
const bm011000i = () => import('@/views/bm/bm011000i');
const bm011000l = () => import('@/views/bm/bm011000l');
const bm012000l = () => import('@/views/bm/bm012000l');
const bm012000i = () => import('@/views/bm/bm012000i');
const bm014000l = () => import('@/views/bm/bm014000l');
const bm014000i = () => import('@/views/bm/bm014000i');
const bm015000l = () => import('@/views/bm/bm015000l');
const bm015000i = () => import('@/views/bm/bm015000i');
const bm016000l = () => import('@/views/bm/bm016000l');
const bm016000i = () => import('@/views/bm/bm016000i');
const bm013000l = () => import('@/views/bm/bm013000l');
const bm013000i = () => import('@/views/bm/bm013000i');

/**
 * Defined Router
 */
export default [
    {
        path: '/bm/bm001000i',
        name: 'Bm001000i',
        component: bm001000i,
        meta: {
            title: 'ユーザマスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm001000l',
        name: 'Bm001000l',
        component: bm001000l,
        meta: {
            title: 'ユーザマスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm002000i',
        name: 'Bm002000i',
        component: bm002000i,
        meta: {
            title: '得意先マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm002000l',
        name: 'Bm002000l',
        component: bm002000l,
        meta: {
            title: '得意先マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm003000i',
        name: 'Bm003000i',
        component: bm003000i,
        meta: {
            title: '得意先担当者マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm003000l',
        name: 'Bm003000l',
        component: bm003000l,
        meta: {
            title: '得意先担当者マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm004000i',
        name: 'Bm004000i',
        component: bm004000i,
        meta: {
            title: '現場マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm004000l',
        name: 'Bm004000l',
        component: bm004000l,
        meta: {
            title: '現場マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm005000i',
        name: 'Bm005000i',
        component: bm005000i,
        meta: {
            title: '隊員マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm005000l',
        name: 'Bm005000l',
        component: bm005000l,
        meta: {
            title: '隊員マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm006000i',
        name: 'Bm006000i',
        component: bm006000i,
        meta: {
            title: '会社情報マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm007000l',
        name: 'Bm007000l',
        component: bm007000l,
        meta: {
            title: '売上項目マスタ一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm007000i',
        name: 'Bm007000i',
        component: bm007000i,
        meta: {
            title: '売上項目マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm008000l',
        name: 'Bm008000l',
        component: bm008000l,
        meta: {
            title: '売上項目変換マスタ一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm009000i',
        name: 'Bm009000i',
        component: bm009000i,
        meta: {
            title: '入金項目マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm009000l',
        name: 'Bm009000l',
        component: bm009000l,
        meta: {
            title: '入金項目マスタ一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm010000l',
        name: 'Bm010000l',
        component: bm010000l,
        meta: {
            title: '締グループマスタ一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm010000i',
        name: 'Bm010000i',
        component: bm010000i,
        meta: {
            title: '締グループマスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm011000i',
        name: 'Bm011000i',
        component: bm011000i,
        meta: {
            title: 'その他売上項目マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm011000l',
        name: 'Bm011000l',
        component: bm011000l,
        meta: {
            title: 'その他売上項目マスタ一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm012000l',
        name: 'Bm012000l',
        component: bm012000l,
        meta: {
            title: '担当区分一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm012000i',
        name: 'Bm012000i',
        component: bm012000i,
        meta: {
            title: '担当区分マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm014000l',
        name: 'Bm014000l',
        component: bm014000l,
        meta: {
            title: '消費税マスタ一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm014000i',
        name: 'Bm014000i',
        component: bm014000i,
        meta: {
            title: '消費税マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm015000l',
        name: 'Bm015000l',
        component: bm015000l,
        meta: {
            title: '品名マスタ一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm015000i',
        name: 'Bm015000i',
        component: bm015000i,
        meta: {
            title: '品名マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm016000l',
        name: 'Bm016000l',
        component: bm016000l,
        meta: {
            title: '品名分類マスタ一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm016000i',
        name: 'Bm016000i',
        component: bm016000i,
        meta: {
            title: '品名分類マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm013000l',
        name: 'Bm013000l',
        component: bm013000l,
        meta: {
            title: '事業所マスタ一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bm/bm013000i',
        name: 'Bm013000i',
        component: bm013000i,
        meta: {
            title: '事業所マスタ',
            layout: 'MainLayout'
        }
    }
];
